import { useMemo } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export function fileUrl(path) {
  return path ? `${BACKEND_URL}/api/files/${path}` : null;
}

export function useApi() {
  const { getToken } = useAuth();
  return useMemo(() => {
    const headers = async () => ({ Authorization: `Bearer ${await getToken()}` });
    return {
      get: async (url) => (await axios.get(`${API}${url}`, { headers: await headers() })).data,
      post: async (url, body) => (await axios.post(`${API}${url}`, body, { headers: await headers() })).data,
      patch: async (url, body) => (await axios.patch(`${API}${url}`, body, { headers: await headers() })).data,
      del: async (url) => (await axios.delete(`${API}${url}`, { headers: await headers() })).data,
      upload: async (url, formData) =>
        (await axios.post(`${API}${url}`, formData, {
          headers: { ...(await headers()), "Content-Type": "multipart/form-data" },
        })).data,
    };
  }, [getToken]);
}
